/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SimpleSearchDocumentList } from '../../models/simple-search-document-list';

export interface VaultGetSimpleSearchDocumentList$Params {

/**
 * GUID of the vault
 */
  vaultId: string;

/**
 * Search text
 */
  searchText: string;

/**
 * Requested document count. Value must be less than or equal to 255
 */
  count?: number;
}

export function vaultGetSimpleSearchDocumentList(http: HttpClient, rootUrl: string, params: VaultGetSimpleSearchDocumentList$Params, context?: HttpContext): Observable<StrictHttpResponse<SimpleSearchDocumentList>> {
  const rb = new RequestBuilder(rootUrl, vaultGetSimpleSearchDocumentList.PATH, 'get');
  if (params) {
    rb.path('vaultId', params.vaultId, {});
    rb.query('searchText', params.searchText, {});
    rb.query('count', params.count, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SimpleSearchDocumentList>;
    })
  );
}

vaultGetSimpleSearchDocumentList.PATH = '/vault/{vaultId}/simple-search/document/list';
